import { createLocale } from "./createLocale";

export const sl = createLocale({
  header: {
    title: "Postanite globalni. 2 $ na Short. Kateri koli jezik!",
    subtitle: "🔥Plačajte samo za rezultat – od $0.089 do $0.009 na sekundo🔥",
  },
  steps: {
    uploadVideo: "Naloži video",
    selectLanguages: "Izberi jezike",
    conversionResult: "Pretvorba in rezultat",
  },
  upload: {
    dragAndDrop: "Povlecite in spustite svojo video datoteko sem",
    orClickToSelect: "ali kliknite za izbiro",
    supportedFormats: "Podprti formati: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Največja velikost datoteke: 200 MB",
    maxDuration: "• Največje trajanje: 30 sek",
    chooseFile: "Izberi datoteko",
    selectedFile: "Izbrana datoteka:",
    size: "Velikost:",
    fileTypeError: "Prosimo, izberite video datoteko",
    fileSizeError: "Velikost datoteke ({size} MB) presega največjo omejitev 200 MB",
    durationError: "Trajanje videa ({duration} sek) presega največjo omejitev 30 sek",
    fileReadError: "Video datoteke ni mogoče prebrati. Poskusite drugo datoteko.",
  },
  languages: {
    sourceAudioLanguage: "Jezik izvornega zvoka",
    targetAudioLanguage: "Jezik ciljnega zvoka",
    selectLanguage: "Izberite jezik...",
  },
  conversion: {
    replaceAudio: "Kloniraj moj glas",
    uploadVideoAndSelectLanguages: "Naložite videoposnetek in izberite jezike za nadaljevanje",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Politika zasebnosti",
    termsOfUse: "Pogoji uporabe",
  },
  languageOptions: {
    sl: "Slovenščina",
  },
});
